<script setup lang="ts">
    import { Procedure } from '@/types';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import EditProcedure from './EditProcedure.vue';

    interface Props {
        procedure: Procedure;
    }

    defineProps<Props>();
</script>

<template>
    <DataTableActions :data="procedure">
        <EditProcedure :procedure="procedure" />
    </DataTableActions>
</template>
